import React, { useState, useEffect, useRef } from 'react';
import useTranslations from '../../../utils/useTranslations';
import Logo from '../../../components/logo';
import backgrounds from '../../../components/backgrounds';
import fileDownload from 'js-file-download';
import Axios from 'axios';
import { getNordVpnAdLink } from 'src/utils/getNordVpnAdLink';
import BenchClient from 'src/utils/benchClient';
import { getCountry } from 'src/utils/country';

const winFilename = 'bittorrent_installer.exe';
const osxFilename = 'BitTorrent.dmg';
const riseEndpoint = 'https://d3q6kme0ccojj5.cloudfront.net';
const cherryWinLink = `https://download-new.utorrent.com/track/beta/endpoint/bittorrent/os/riserollout?filename=${winFilename}`;
const cherryWrappedWinLink = `http://download-lb.utorrent.com/uuid/9ebac4d6-cede-4488-9c4e-9f86923bea61?filename=${winFilename}`;
const cherryWin7Link = 'https://download-new.utorrent.com/endpoint/bittorrent/track/beta/os/win7';
const cherryOsxLink = `https://download-new.utorrent.com/endpoint/btmac/os/osx/track/stable?filename=${osxFilename}`;
const heightParentHeightRatio = 0.45;
const nordVpnLink = getNordVpnAdLink();

const DownloadsCompleteClassic = (props) => {
    const { text, locale } = props.pageContext;
    const t = useTranslations(text);

    const [isMac, setIsMac] = useState(false);
    const [fs, setFs] = useState(16);
    const [cherryLink, setCherryLink] = useState(cherryWinLink);

    const innerContainerRef = useRef();

    const adjustFs = (prevFs) => {
        let height = innerContainerRef.current.clientHeight;
        let parentHeight = innerContainerRef.current.offsetParent.clientHeight;
        let fs = prevFs - 0.5;
        if (fs <= 12) {
            return;
        }
        if (height / parentHeight > heightParentHeightRatio) {
            setFs(fs);
        }
    };

    useEffect(() => {
        adjustFs(fs);
    }, [fs]);

    useEffect(() => {
        //show a different cherry link for window 7 and below users
        const isBrowser = typeof window !== 'undefined';
        const ua = isBrowser ? window.navigator.userAgent : '';

        let cherryDownloadLink = cherryWinLink;

        const isWin7AndAbove =
            isBrowser && ua.includes('Windows NT')
                ? parseFloat(ua.split('Windows NT')[1].split(';')[0]) > 6.1
                : undefined;

        if (isWin7AndAbove === false) {
            cherryDownloadLink = cherryWin7Link;
        }

        if (window.gatsbyIsMac) {
            cherryDownloadLink = cherryOsxLink;
            setIsMac(true);
        }

        let locationState = props.location.state;

        if (locationState) {
            if (locationState.force) {
                let forceValue = Array.isArray(locationState.force) ? locationState.force[0] : locationState.force;
                if (forceValue === 'Win') {
                    cherryDownloadLink = cherryWinLink;
                    setIsMac(false);
                } else if (forceValue === 'Osx') {
                    cherryDownloadLink = cherryOsxLink;
                    setIsMac(true);
                }
            }
        }

        setCherryLink(cherryDownloadLink);

        let download = async () => {
            const countryCode = await getCountry();
            let benches = [BenchClient.ping('load.classic_download')];
            // file download action
            // attempt rise only for windows
            if (cherryDownloadLink === cherryWinLink) {

                Axios.get(riseEndpoint, {
                    responseType: 'blob',
                    params: {
                        ic_user_id: '11091',
                        c: '1',
                        l: 'URL',
                        v: '2.1',
                    },
                })
                    .then((response) => fileDownload(response.data, winFilename))
                    .then(_ => {
                        benches.push(BenchClient.ping(`download.classic.win.rise.success`).catch(_ => {}));
                    })
                    .catch((e) => {
                        let status = 'unknown';
                        if (e.message.toLowerCase().includes('cors') || e.message.toLowerCase().includes('network error')) {
                            status = 'cors';
                        } else if (e.response && e.response.status) {
                            status = e.response.status;
                        }
                        benches.push(BenchClient.ping(`download.classic.win.rise.error.${status}`));

                        setTimeout(async () => {
                            await Promise.all(benches);
                            window.location = cherryDownloadLink;
                        }, 1);
                    });
            } else {
                setTimeout(async () => {
                    await Promise.all(benches);
                    window.location = cherryDownloadLink;
                }, 100);
            }
            await Promise.all(benches);
        }
        download();
    }, [props.location]);

    var winDisplay = style.show;
    var macDisplay = style.hide;
    if (isMac) {
        winDisplay = style.hide;
        macDisplay = style.show;
    }

    if (locale === 'en' || locale === 'ja' || locale === 'zh_tw') {
        var runInstaller = (
            <li className="my-3">
                {t('Run')}
                {' '}
                <span className="text-primary" style={winDisplay}>
                    {winFilename}
                </span>
                <span className="text-primary" style={macDisplay}>
                    {osxFilename}
                </span>
                {' '}
                {t('to install')}
            </li>
        );

        var tryAgain = (
            <>
                <p className="text-danger font-weight-bold ml-3" style={{ ...font.md }}>
                    * {t("if you have trouble downloading or installing, try this version.", {
                        "version": <a href={cherryLink} className="text-primary">{t(`version`)}</a>
                    })}
                </p>
            </>
        );
    } else {
        runInstaller = t(`Run BitTorrent.dmg to install`);
        runInstaller = isMac
            ? runInstaller.replace('BitTorrent.dmg', `<span class='text-primary'>${osxFilename}</span>`)
            : runInstaller.replace('BitTorrent.dmg', `<span class='text-primary'>${winFilename}}</span>`);
        runInstaller = <li className="my-3" dangerouslySetInnerHTML={{ __html: runInstaller }}></li>;

        tryAgain = (
            <>
                <p className="text-danger font-weight-bold ml-3" style={{ ...font.md }}>
                    * {t("if you have trouble downloading or installing, try this version.", {
                        "version": <a href={cherryLink} className="text-primary">{t(`version`)}</a>
                    })}
                </p>
                <br />
            </>
        );
    }

    if (!isMac) {
        const catLink = locale
            ? `url(/images/pro-free-trial/cat-14days-${locale}.png)`
            : `url(/images/pro-free-trial/cat-14days-en.png)`;
        const catStyle = {
            background: catLink,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            aspectRatio: '1083/900',
            width: '100%',
            display: 'block',
        };

        return (
            <div
                className="download-complete-container download-complete-container-light top-section-container d-flex align-items-center flex-column overflow-auto background-noise-light"
                style={backgrounds.lightBg}
            >
                <div
                    className="container pt-0 px-5 mb-5 download-complete-inner-container"
                    ref={innerContainerRef}
                    style={{ fontSize: `${fs}px` }}
                >
                    <p
                        className="text-dark p-absolute text-center font-weight-bold"
                        style={{
                            fontSize: `${fs * 2}px`,
                            ...adStyle.headerSpacing,
                        }}
                    >
                        {t('Thank you for downloading')}
                    </p>
                    <div className="row">
                        <div className="col-lg-7 col-md-6 d-flex flex-column justify-content-center">
                            <Logo
                                productName="Classic"
                                color="black"
                                tag="p"
                                fsMax={26}
                                fsCoefficient={18}
                                className="pdlp-logo text-left ml-3"
                            />
                            <ul className="m-0 download-complete-list text-left" style={adStyle.font_md}>
                                <li className="my-3">{t('Wait for the download to finish*')}</li>
                                {runInstaller}
                                <li className="my-3">{t('BitTorrent Classic will run once installed')}</li>
                            </ul>
                            {tryAgain}
                        </div>
                        <div className="col-lg-5 col-md-6 text-center" style={{ fontSize: `${fs}px` }}>
                            <a
                                id="downloads-complete-pro-free-trial"
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://store.bittorrent.com/849/purl-btprotrialweb14"
                                style={catStyle}
                            ></a>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-12">
                            <a target="_blank" rel="noopener noreferrer" href={nordVpnLink} style={nordStyle}></a>
                        </div>
                    </div>
                </div>
                <div className="download-complete-bottom-container d-flex align-self-start with-pro-free-trial" />
            </div>
        );
    } else {
        return (
            <div
                className="download-complete-container download-complete-container-light top-section-container d-flex align-items-center justify-content-end flex-column background-noise-light"
                style={backgrounds.lightBg}
            >
                <div
                    className="container pt-0 px-5 mb-0 download-complete-inner-container"
                    ref={innerContainerRef}
                    style={{ fontSize: `${fs}px` }}
                >
                    <p
                        className="text-dark p-absolute text-center font-weight-bold"
                        style={{
                            fontSize: `${fs * 2}px`,
                            ...adStyle.headerSpacing,
                        }}
                    >
                        {t('Thank you for downloading')}
                    </p>
                    <div className="row">
                        <div className="col-lg-5 d-flex flex-column justify-content-center">
                            <Logo
                                productName="Classic"
                                color="black"
                                tag="p"
                                fsMax={26}
                                fsCoefficient={18}
                                className="pdlp-logo text-nowrap text-left text-lg-right ml-3 ml-lg-0"
                            />
                        </div>
                        <div className="col-lg-7">
                            <ul className="m-0 download-complete-list" style={font.lg}>
                                <li className="my-3">{t('Wait for the download to finish*')}</li>
                                {runInstaller}
                                <li className="my-3">{t('BitTorrent Classic will run once installed')}</li>
                            </ul>
                            {tryAgain}
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-12">
                            <a target="_blank" rel="noopener noreferrer" href={nordVpnLink} style={nordStyle}></a>
                        </div>
                    </div>
                </div>
                <div className="download-complete-bottom-container w-100 d-flex"></div>
            </div>
        );
    }
};

export default DownloadsCompleteClassic;

const adStyle = {
    font_lg: {
        fontSize: '2em',
    },
    font_md: {
        fontSize: '1.5em',
    },
    headerSpacing: {
        padding: '1em 0',
        margin: '1em 0',
    },
};

const font = {
    lg: {
        fontSize: '2em',
    },
    md: {
        fontSize: '1.25em',
    },
};

const nordStyle = {
    background: 'url(/images/nord-images/affiliate-features-campaign-1500x300.png)',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    aspectRatio: '1500/300',
    width: '100%',
    display: 'block',
};

const style = {
    show: {
        display: 'inline-block',
    },
    hide: {
        display: 'none',
    },
};
